import { mainColor, UNIT } from '../../constants/theme';

export const styles = () => ({
  root: {
    marginTop: UNIT,
    borderColor: mainColor.colorGray,
    border: '1px solid',
    backgroundColor: mainColor.colorWhite,
    borderRadius: UNIT,
    overflow: 'hidden',
    elevation: 1
  },
  card: {
    height: UNIT * 9.375,
    width: UNIT * 11.71875,
    borderRadius: UNIT,
    borderColor: mainColor.colorGray,
    border: '1px solid ',
    display: 'flex',
    zIndex: 0,
    justifyContent: 'center'
  },

  media: {
    width: '100%',
    height: '100%'
  },

  titleHeading: {
    fontSize: UNIT,
    fontWeight: '600'
  },
  icon: {
    fontSize: UNIT * 1.5,

    backgroundColor: 'transparent',
    color: mainColor.colorBlack
  },
  noImageIcon: {
    width: '50%',
    height: '50%',
    alignSelf: 'center',
    color: 'gray'
  },
  mediaStyle: { fontSize: UNIT, color: 'gray', fontWeight: 'bold' },
  imageStyle: {
    width: UNIT * 1.5,
    height: UNIT * 1.25
  }
});
